import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import settings from './modules/settings'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    permission,
    tagsView,
    settings
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    menus: state => state.user.menus,
    moduleEnables: state => state.user.moduleEnables,
    permission_routes: state => state.permission.routes,
    sidebar: state => state.settings.sidebar,
    device: state => state.settings.device,
    siteName: state => state.settings.siteName,
    copyright: state => state.settings.copyright,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews
  }
})
